<template>
    <div class="home" v-if="isShow">
        <!--轮播-->
        <div class="ho_header">
            <el-carousel
                    ref="carousel"
                    class="h_c_lunbo"
                    height="540px"
                    arrow="never"
                    indicator-position="none"
                    :autoplay=false
                    trigger="click">
                <el-carousel-item
                        :key="index"
                        v-for="(item,index) in lunboArr">
                    <img :src="IMGURL + item.fimageUrl" width="100%" height="100%" alt="">
                </el-carousel-item>
            </el-carousel>
            <div class="h_c_ref">
                <div class="h_c_btn">
                    <a @click="handleClick('left')" href="javascript:;" class="h_c_btn_left"></a>
                    <a @click="handleClick('right')" href="javascript:;" class="h_c_btn_right"></a>
                </div>
                <el-carousel
                        ref="carouselTitle"
                        height="260px"
                        trigger="click"
                        @change="carTitle"
                        arrow="never">
                    <el-carousel-item
                            :key="index"
                            v-for="(item,index) in lunboArr">
                        <div style="background-color: #fff">
                            <h3>{{ item.fimageTitle }}</h3>
                            <div class="h_c_r_p" v-html="item.fimageContent"></div>
                            <router-link to="/steward" class="h_c_r_btn">了解更多</router-link>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <!--公司介绍-->
        <div class="h_c_company" v-if="companyArr.length !== 0">
            <div class="h_c_c_left">
                <img :src="IMGURL + companyArr[0].fimageUrl" alt="">
            </div>
            <div class="h_c_c_right">
                <h2>ABOUT</h2>
                <div class="h_c_c_ref">
                    <h3>{{ companyArr[0].fimageTitle }}</h3>
                    <p v-html="companyArr[0].fimageContent"></p>
                    <router-link to="/company" class="h_c_r_btn">
                        了解更多
                    </router-link>
                </div>
            </div>
            <p class="h_c_c_r_font">AB US</p>
        </div>
        <!--环保“易”起来-->
        <div class="h_c_protection">
            <h2>环保“易”起来</h2>
            <ul class="h_c_p_conent">
                <li
                    v-for="(item,index) in mangerArr"
                    :key="index"
                >
                    <div class="h_c_p_co_img">
                        <img :src="IMGURL + item.fimageUrl" alt="">
                    </div>
                    <i class="h_c_p_c_icon">
                        <img :src="IMGURL + item.flittleImageUrl" alt="">
                    </i>
                    <p>{{ item.fimageTitle }}</p>
                </li>
                <!-- 模板
                <li>
                    <img src="../../assets/images/probg1.png" alt="">
                    <i class="h_c_p_c_icon">
                        <img src="../../assets/images/icon-huojian.png" alt="">
                    </i>
                    <p>及时响应 快速解决</p>
                </li>-->
            </ul>
        </div>
        <!--友情链接-->
        <FriendLink />
    </div>
</template>

<script>
    import FriendLink from '../FriendLink'
    import axios from '../../assets/js/baseaxios'
    import baseUrl from '../../assets/js/baseUrl'
    export default {
        name: "home",
        data(){
            return{
                IMGURL: '',
                isShow: false, //数据到了渲染页面
                lunboArr:[],
                companyArr:[],
                mangerArr:[],
                currentIten: 0,
            }
        },
        mounted(){
            this.IMGURL = baseUrl.IMG_URL
            this.getData()
        },
        methods:{
            getData(){
                axios.get(`/api/index`).then(res=>{
                    if(res.data.success){
                        let items = res.data.items
                        items.forEach(btn=>{
                            switch (btn.fimageType) {
                                case 'A':
                                    this.lunboArr.push(btn)
                                    break
                                case 'B':
                                    this.mangerArr.push(btn)
                                    break
                                case 'C':
                                    this.companyArr.push(btn)
                                    break
                            }
                        })
                        this.isShow = true
                    }else{
                        this.$message.warning(res.data.msg)
                    }
                })
            },
            handleClick(val){
                let oCar2 = this.$refs.carouselTitle
                switch (val) {
                    case 'left':
                        oCar2.prev()
                        break
                    case 'right':
                        oCar2.next()
                        break
                }
            },
            carTitle(x){ //x表示当前到第几张
                // console.log(x)
                this.currentIten = x
                this.$refs.carousel.setActiveItem(x)
            }
        },
        components:{
            FriendLink
        },
    }
</script>

<style scoped>
    .home{
        width: 100%;
    }
    .ho_header{
        position: relative;
        height: 800px;
    }
    .h_c_lunbo img{
        position: absolute;
        left: 50%;
        margin-left: -960px;
        width: 1920px;
        height: 540px;
    }
    .h_c_ref{
        position: absolute;
        left: 50%;
        bottom: 231px;
        width: 1100px;
        height: 260px;
        text-align: center;
        transform: translateX(-50%);
        border-radius: 5px;
        z-index: 99;
    }
    .h_c_ref .h_c_btn a{
        position: absolute;
        top: 208px;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        z-index: 100;
    }
    .h_c_ref .h_c_btn a.h_c_btn_left{
        left: 60px;
        background: url('../../assets/images/icon-left.png') no-repeat center/40px;
    }
    .h_c_ref .h_c_btn a.h_c_btn_right{
        right:60px;
        background: url('../../assets/images/icon-right.png') no-repeat center/40px;
    }
    .h_c_ref .h_c_btn a.h_c_btn_left::after,
    .h_c_ref .h_c_btn a.h_c_btn_right::after{
        display: none;
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: rgba(204,204,204,.15);
    }
    .h_c_ref .h_c_btn a:hover::after{
        display: block;
    }
    .h_c_ref h3{
        padding-top: 30px;
        color: #333333;
        font-size: 24px;
        font-weight: bold;
        text-align: center;
    }
    .h_c_ref .h_c_r_btn{
        display: inline-block;
        width: 132px;
        height: 46px;
        line-height: 46px;
        text-align: left;
        background-color: #00B76B;
        font-size: 12px;
        color: #fff;
        text-indent:27px;
        border-radius:5px;
        cursor: pointer;
        background-image: url("../../assets/images/icon_jiantou.png");
        background-size: 24px 24px;
        background-position: 81px 14px;
        background-repeat: no-repeat;
    }

    /*公司介绍*/
    .h_c_company{
        width: 1100px;
        height: 510px;
        margin:-30px auto 80px;
        position: relative;
    }
    .h_c_c_left{
        position: absolute;
        top: 50px;
        left: 0;
        width: 550px;
        height: 410px;
        z-index: 2;
        overflow: hidden;
    }
    .h_c_c_left img{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        height: 100%;
    }
    .h_c_c_right{
        position: absolute;
        right: 0;
        top: 0;
        width: 680px;
        height: 510px;
        background-color: #00B76B;
        z-index: 1;
    }
    .h_c_c_right h2{
        font-family: 'Helvetica Neue';
        letter-spacing: 8px;
        font-size: 80px;
        line-height: 108.5px;
        color: rgba(255,255,255,0.4);
        text-indent: 10px;
    }
    .h_c_c_right .h_c_c_ref{
        position: absolute;
        left:180px;
        top:130px;
        font-family: '微软雅黑';
    }
    .h_c_c_ref h3{
        font-size: 26px;
        color: #fff;
        margin-bottom: 30px;
    }
    .h_c_c_ref p{
        font-size: 14px;
        line-height: 19px;
        color: #fff;
        letter-spacing: 1px;
        margin-bottom: 60px;
    }
    .h_c_c_right .h_c_r_btn{
        display: inline-block;
        width: 132px;
        height: 46px;
        line-height: 46px;
        text-align: left;
        background-color: #fff;
        font-size: 12px;
        color: #00B76B;
        text-indent:27px;
        border-radius:5px;
        cursor: pointer;
        background-image: url("../../assets/images/icon_jiantou2.png");
        background-size: 24px 24px;
        background-position: 81px 14px;
        background-repeat: no-repeat;
    }
    .h_c_c_r_font{
        position: absolute;
        top: 0px;
        left: 419px;
        width: 131px;
        height: 217px;
        line-height: 108.5px;
        background-color: #94F3CC;
        font-family: 'Helvetica Neue';
        letter-spacing: 8px;
        font-size: 80px;
        text-align: right;
        color: rgba(255,255,255,0.4);
        z-index: 3;
    }
    /*环保*/
    .h_c_protection{
        width: 1100px;
        margin: 0 auto;
        margin-bottom: 80px;
    }
    .h_c_protection h2 {
        font-size: 30px;
        color: #333;
        text-align: center;
        margin-bottom: 40px;
    }
    .h_c_protection ul{
        height: 450px;
    }
    .h_c_protection ul li{
        position: relative;
        float: left;
        width: 344px;
    }
    .h_c_protection ul li .h_c_p_co_img{
        position: relative;
        display: block;
        width: 344px;
        height: 360px;
        overflow: hidden;
    }
    .h_c_protection ul li .h_c_p_co_img img{
        position: absolute;
        height: 100%;
        left: 50%;
        transform: translateX(-50%);
    }
    .h_c_protection ul li:after{
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 360px;
        background-color: rgba(0,183,107,.3);
    }
    .h_c_protection ul li+li{
        margin-left: 34px;
    }
    .h_c_protection ul li .h_c_p_c_icon{
        position: absolute;
        left: 122px;
        top: 130px;
        width: 100px;
        height: 100px;
        z-index: 2;
    }
    .h_c_p_c_icon img{
        display: block;
        width: 100%;
        height: 100%;
    }
    .h_c_protection ul li p {
        width: 342px;
        height: 89px;
        border:1px solid #E5E5E5;
        border-top: none;
        font-family: "微软雅黑";
        font-size: 22px;
        font-weight: bold;
        color: #333;
        line-height: 89px;
        text-align: center;
        transition: .3s;
    }
    .h_c_protection ul li:hover p{
        border-color: #00B76B;
    }
</style>